module.exports = function () {
  /**
  * @file 使用postmessage调用端能力的业务方
  * @author renzhonghua@baidu.com
  */
  return ['swan'];
}();